import { Cpu as Cpu_zoomg } from './Cpu.zoomg';
import { Cpu as Cpu_zoomit } from './Cpu.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Cpu_zoomg;

    default:
      return Cpu_zoomit;
  }
};

export const Cpu = IconRenderer();
